"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageDropdown = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const Language_1 = __importDefault(require("@mui/icons-material/Language"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const LanguageDropdown = (props) => {
    const theme = (0, material_1.useTheme)();
    const { currentLocale, updateStore, enabledLocales } = props;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const updateUserSelectedLocale = (selectedLocale) => {
        if (currentLocale === selectedLocale) {
            handleClose();
        }
        else {
            localStorage.setItem('language', selectedLocale);
            updateStore('userSelectedLocale', selectedLocale);
        }
    };
    if (enabledLocales.length < 1) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.IconButton, { className: "icon-circle", onClick: handleClick, edge: "end", "aria-controls": open ? 'account-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, id: "aqa_navigation_language" },
            react_1.default.createElement(Language_1.default, { sx: { color: theme.palette.colorOnAppBar } })),
        react_1.default.createElement(material_1.Menu, { anchorEl: anchorEl, id: "account-menu", "data-testid": "locale-list", open: open, onClose: handleClose, onClick: handleClose, PaperProps: {
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                },
            }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, enabledLocales.map(locale => (react_1.default.createElement(material_1.MenuItem, { className: "locale", "data-testid": "locale", key: locale.abbreviation, onClick: () => {
                updateUserSelectedLocale(locale.abbreviation);
                if (window.usercentrics) {
                    window.usercentrics.updateLanguage(locale.abbreviation);
                }
                if (process.env.PLATFORM === 'webapp' && window.location.pathname.includes('/activities')) {
                    window.location.reload();
                }
            } }, locale.name))))));
};
exports.LanguageDropdown = LanguageDropdown;
const mapStoreToProps = store => ({
    enabledLocales: store.getValue('enabledLocales'),
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.LanguageDropdown);
